import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-loader-admin',
  templateUrl: './loader-admin.component.html',
  styleUrls: ['./loader-admin.component.css']
})
export class LoaderAdminComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /app/src/app/components/loader-admin/loader-admin.component.ts